// @flow strict
import init from "@kiwicom/nitro/lib/services/session/init"
import { sessionDefault, type Session } from "@kiwicom/nitro/lib/records/Session"

const getSession = (): Session => {
  // Taken from 'cuckoo.js'
  if (typeof window !== "undefined" && window.SP_GLOBALS) {
    return init()
  }
  return sessionDefault // server fallback
}

const session = getSession()

export default session
